// Trading theme colors
export const TRADING_COLORS = {
  bg: '#0b0e11',
  bgSecondary: '#121318',
  bgTertiary: '#181b20',
  bgElevated: '#1e2026',
  bgInput: '#1e2026',
  
  yellow: '#f0b90b',
  yellowSoft: 'rgba(240, 185, 11, 0.1)',
  
  long: '#0ecb81',
  longBg: 'rgba(14, 203, 129, 0.1)',
  short: '#f6465d',
  shortBg: 'rgba(246, 70, 93, 0.1)',
  
  text: '#eaecef',
  textSecondary: '#848e9c',
  textTertiary: '#5e6673',
  textMuted: '#474d57',
  
  border: '#2b3139',
};

// Cryptocurrency icons
export const CRYPTO_ICONS = {
  // Top 10
  BTC: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  ETH: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  USDT: 'https://assets.coingecko.com/coins/images/325/small/Tether.png',
  BNB: 'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  SOL: 'https://assets.coingecko.com/coins/images/4128/small/solana.png',
  XRP: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png',
  USDC: 'https://assets.coingecko.com/coins/images/6319/small/usdc.png',
  ADA: 'https://assets.coingecko.com/coins/images/975/small/cardano.png',
  DOGE: 'https://assets.coingecko.com/coins/images/5/small/dogecoin.png',
  TRX: 'https://assets.coingecko.com/coins/images/1094/small/tron-logo.png',
  
  // Top 11-30
  AVAX: 'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png',
  SHIB: 'https://assets.coingecko.com/coins/images/11939/small/shiba.png',
  DOT: 'https://assets.coingecko.com/coins/images/12171/small/polkadot.png',
  LINK: 'https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png',
  MATIC: 'https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png',
  POL: 'https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png',
  LTC: 'https://assets.coingecko.com/coins/images/2/small/litecoin.png',
  BCH: 'https://assets.coingecko.com/coins/images/780/small/bitcoin-cash-circle.png',
  UNI: 'https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png',
  ATOM: 'https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png',
  XLM: 'https://assets.coingecko.com/coins/images/100/small/Stellar_symbol_black_RGB.png',
  ETC: 'https://assets.coingecko.com/coins/images/453/small/ethereum-classic-logo.png',
  XMR: 'https://assets.coingecko.com/coins/images/69/small/monero_logo.png',
  OKB: 'https://assets.coingecko.com/coins/images/4463/small/WeChat_Image_20220118095654.png',
  FIL: 'https://assets.coingecko.com/coins/images/12817/small/filecoin.png',
  HBAR: 'https://assets.coingecko.com/coins/images/3688/small/hbar.png',
  APT: 'https://assets.coingecko.com/coins/images/26455/small/aptos_round.png',
  VET: 'https://assets.coingecko.com/coins/images/1167/small/VeChain-Logo-768x725.png',
  NEAR: 'https://assets.coingecko.com/coins/images/10365/small/near.jpg',
  MKR: 'https://assets.coingecko.com/coins/images/1364/small/Mark_Maker.png',
  
  // Top 31-60
  ARB: 'https://assets.coingecko.com/coins/images/16547/small/photo_2023-03-29_21.47.00.jpeg',
  OP: 'https://assets.coingecko.com/coins/images/25244/small/Optimism.png',
  INJ: 'https://assets.coingecko.com/coins/images/12882/small/Secondary_Symbol.png',
  SUI: 'https://assets.coingecko.com/coins/images/26375/small/sui_asset.jpeg',
  AAVE: 'https://assets.coingecko.com/coins/images/12645/small/AAVE.png',
  GRT: 'https://assets.coingecko.com/coins/images/13397/small/Graph_Token.png',
  ALGO: 'https://assets.coingecko.com/coins/images/4380/small/download.png',
  FTM: 'https://assets.coingecko.com/coins/images/4001/small/Fantom_round.png',
  SAND: 'https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg',
  MANA: 'https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png',
  AXS: 'https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png',
  THETA: 'https://assets.coingecko.com/coins/images/2538/small/theta-token-logo.png',
  EOS: 'https://assets.coingecko.com/coins/images/738/small/eos-eos-logo.png',
  FLOW: 'https://assets.coingecko.com/coins/images/13446/small/5f6294c0c7a8cda55cb1c936_Flow_Wordmark.png',
  XTZ: 'https://assets.coingecko.com/coins/images/976/small/Tezos-logo.png',
  EGLD: 'https://assets.coingecko.com/coins/images/12335/small/egld-token-logo.png',
  CHZ: 'https://assets.coingecko.com/coins/images/8834/small/CHZ_Token_updated.png',
  SNX: 'https://assets.coingecko.com/coins/images/3406/small/SNX.png',
  CRV: 'https://assets.coingecko.com/coins/images/12124/small/Curve.png',
  LDO: 'https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png',
  
  // Top 61-100
  RNDR: 'https://assets.coingecko.com/coins/images/11636/small/rndr.png',
  FET: 'https://assets.coingecko.com/coins/images/5681/small/Fetch.jpg',
  RUNE: 'https://assets.coingecko.com/coins/images/6595/small/Rune200x200.png',
  KAVA: 'https://assets.coingecko.com/coins/images/9761/small/kava.png',
  GALA: 'https://assets.coingecko.com/coins/images/12493/small/GALA-COINGECKO.png',
  IMX: 'https://assets.coingecko.com/coins/images/17233/small/immutableX-symbol-BLK-RGB.png',
  MINA: 'https://assets.coingecko.com/coins/images/15628/small/JM4_vQ34_400x400.png',
  APE: 'https://assets.coingecko.com/coins/images/24383/small/apecoin.jpg',
  NEO: 'https://assets.coingecko.com/coins/images/480/small/NEO_512_512.png',
  KLAY: 'https://assets.coingecko.com/coins/images/9672/small/klaytn.png',
  CAKE: 'https://assets.coingecko.com/coins/images/12632/small/pancakeswap-cake-logo_%281%29.png',
  ZIL: 'https://assets.coingecko.com/coins/images/2687/small/Zilliqa-logo.png',
  ENJ: 'https://assets.coingecko.com/coins/images/1102/small/enjin-coin-logo.png',
  BAT: 'https://assets.coingecko.com/coins/images/677/small/basic-attention-token.png',
  DASH: 'https://assets.coingecko.com/coins/images/19/small/dash-logo.png',
  ZEC: 'https://assets.coingecko.com/coins/images/486/small/circle-zcash-color.png',
  COMP: 'https://assets.coingecko.com/coins/images/10775/small/COMP.png',
  YFI: 'https://assets.coingecko.com/coins/images/11849/small/yearn.jpg',
  '1INCH': 'https://assets.coingecko.com/coins/images/13469/small/1inch-token.png',
  SUSHI: 'https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png',
  
  // Meme & Trending
  PEPE: 'https://assets.coingecko.com/coins/images/29850/small/pepe-token.jpeg',
  WIF: 'https://assets.coingecko.com/coins/images/33566/small/dogwifhat.jpg',
  FLOKI: 'https://assets.coingecko.com/coins/images/16746/small/PNG_image.png',
  BONK: 'https://assets.coingecko.com/coins/images/28600/small/bonk.jpg',
  BOME: 'https://assets.coingecko.com/coins/images/36071/small/bome.png',
  WLD: 'https://assets.coingecko.com/coins/images/31069/small/worldcoin.jpeg',
  ORDI: 'https://assets.coingecko.com/coins/images/30162/small/ordi.png',
  NOT: 'https://assets.coingecko.com/coins/images/36632/small/notcoin.jpg',
  TON: 'https://assets.coingecko.com/coins/images/17980/small/ton_symbol.png',
  SEI: 'https://assets.coingecko.com/coins/images/28205/small/Sei_Logo_-_Transparent.png',
  TIA: 'https://assets.coingecko.com/coins/images/31967/small/tia.jpg',
  JUP: 'https://assets.coingecko.com/coins/images/34188/small/jup.png',
  PYTH: 'https://assets.coingecko.com/coins/images/31924/small/pyth.png',
  STX: 'https://assets.coingecko.com/coins/images/2069/small/Stacks_logo_full.png',
  BLUR: 'https://assets.coingecko.com/coins/images/28453/small/blur.png',
  
  // DeFi & Infrastructure
  DYDX: 'https://assets.coingecko.com/coins/images/17500/small/hjnIm9bV.jpg',
  GMX: 'https://assets.coingecko.com/coins/images/18323/small/arbit.png',
  PENDLE: 'https://assets.coingecko.com/coins/images/15069/small/Pendle_Logo_Normal-03.png',
  SSV: 'https://assets.coingecko.com/coins/images/19155/small/ssv.png',
  ENS: 'https://assets.coingecko.com/coins/images/19785/small/acatxTm8_400x400.jpg',
  RPL: 'https://assets.coingecko.com/coins/images/2090/small/rocket_pool_%28RPL%29.png',
  OSMO: 'https://assets.coingecko.com/coins/images/16724/small/osmo.png',
  CFX: 'https://assets.coingecko.com/coins/images/13079/small/3vuYMbjN.png',
  KAS: 'https://assets.coingecko.com/coins/images/25751/small/kaspa-icon-exchanges.png',
  ROSE: 'https://assets.coingecko.com/coins/images/13162/small/rose.png',
};

// Animation styles for native-like feel
export const TRADING_ANIMATIONS = `
  @keyframes slideUp {
    from { transform: translateY(100%); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  .slide-up { animation: slideUp 0.3s ease-out; }
  .fade-in { animation: fadeIn 0.2s ease-out; }
  .pulse { animation: pulse 1.5s ease-in-out infinite; }
  .shimmer {
    background: linear-gradient(90deg, #1e2026 25%, #2b3139 50%, #1e2026 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
  }
  
  /* Touch feedback */
  .touch-scale {
    transition: transform 0.1s ease;
  }
  .touch-scale:active {
    transform: scale(0.98);
  }
  
  /* Smooth transitions */
  .smooth-transition {
    transition: all 0.2s ease;
  }
  
  /* Custom scrollbar for mobile */
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

// Inject animations once
export const injectTradingAnimations = () => {
  if (typeof document !== 'undefined' && !document.getElementById('trading-animations')) {
    const styleEl = document.createElement('style');
    styleEl.id = 'trading-animations';
    styleEl.textContent = TRADING_ANIMATIONS;
    document.head.appendChild(styleEl);
  }
};
